var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ticket-page"},[_c('van-icon',{attrs:{"name":"passed","size":"60","color":"#07c160"}}),_c('div',{staticClass:"text"},[_vm._v("支付已完成")]),_c('van-button',{attrs:{"type":"primary","round":"","block":""},on:{"click":_vm.goToPayLoading}},[_vm._v(" 返回 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }